/* eslint-disable import/prefer-default-export */

import { useMemo, useState, useRef, useCallback } from 'react';
import { debounce } from 'lodash';

export const useUpdateUser = user => {
  const company = useMemo(() => {
    return {
      _id: user?.company,
      name: user?.companyName,
      type: user?.companyType,
    };
  }, [user]);

  const DEBOUNCED_VALUE = useRef(500);

  const [companyState, setCompanyState] = useState(company.name);

  const handleChange = useCallback(e => {
    e.preventDefault();
    const { value } = e.target;
    setCompanyState(value);
  }, []);

  const onCompanyStateChange = debounce(handleChange, DEBOUNCED_VALUE?.current);

  return {
    company,
    companyState,
    onCompanyStateChange,
  };
};
